import React from 'react'
import '../charts.scss'
import classNames from 'classnames'

export const PerformanceIndicatorBar = ({ percent }) => {
  const failing_average = 100 - percent

  return (
    <div className="progress_bar performance-indicator-bar" data-testid="performance-indicator-bar">
      <div
        className={classNames(
          percent > 99 ? 'uniform-status-border' : 'some-passing-border',
          'passing-bar'
        )}
        style={{
          width: `${percent}%`,
        }}
      />
      <div
        className={classNames(
          failing_average > 99 ? 'uniform-status-border' : 'some-failing-border',
          'failing-bar'
        )}
        style={{
          width: `${failing_average}%`,
        }}
      />
    </div>
  )
}
